import React from 'react';
import Row from '../../components/Row';
import Card from '../../components/Card';
import CardHeader from '../../components/card-header/CardHeader';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../components/CardBody';
import Paginator from '../../components/Paginator';
import { WorkSearchRequest } from './work-search/WorkSearchRequest';
import { WorkSearchTask } from './work-search/WorkSearchTask';
import { PsWork } from '../PsWork';
import { WorkListTable } from './WorkListTable';
import PropTypes from 'prop-types';
import { WorkState } from '../../model/WorkState';
import { CurrentUser } from '../../model/CurrentUser';
import { connect } from 'react-redux';

class WorkListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: props.initialCardState.search,
            filter: props.initialCardState.filter,
            loading: false,
            filters: this.initialFilterOptions(),
            collapsed: props.initialCardState.collapsed,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        if (!this.state.collapsed) {
            this.listWorks();
        }
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { search, filter, collapsed } = this.state;

        if ((prevState.collapsed !== collapsed) && !collapsed) {
            this.listWorks();
        }

        if ( prevState.filter !== filter ) {
            saveCardState({ filter });
        }

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }

        if ( prevState.collapsed !== collapsed ) {
            saveCardState({ collapsed });
        }
    }

    render() {
        const {
            companyManagement,
            currentUser,
        } = this.props;

        const {
            data,
            error,
            search,
            loading,
            collapsed,
            pagination,
        } = this.state;

        const enableEmailAlerts = currentUser.enableEmailAlerts();

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_OBRAS').toUpperCase()}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={true}
                                filterOptions={this.filterOptions()}
                                searchText={search}
                                onRefresh={this.listWorks}
                                onSearch={this.search}
                                collapsed={collapsed}
                                onCollapsed={this.collapse}
                            />
                        )}
                    />
                    {
                        !collapsed ? (
                            <CardBody>
                                <WorkListTable
                                    data={data}
                                    error={error}
                                    companyManagement={companyManagement}
                                    enableEmailAlerts={enableEmailAlerts}
                                />
                                <Paginator
                                    data={pagination}
                                    onPage={this.selectPage}
                                />
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }

    collapse = () => {
        this.setState((prevState) => ( { collapsed: !prevState.collapsed } ));
    };

    search = (search) => {
        this.setState({ search, page: 1 }, this.listWorks);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listWorks);
    };

    listWorks = () => {
        const { companyManagement } = this.props;
        const { page, search, filter } = this.state;
        const request = new WorkSearchRequest(companyManagement);

        request.setPage(page);
        request.setTerm(search);
        request.setState(filter);

        new WorkSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const data = PsWork.fromAPIConstructionSites(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    initialFilterOptions = () => {
        return [
            {
                id: WorkState.ALL,
                title: I18nUtils.tr('TR_TODAS'),
                onClick: () => this.setState({ filter: WorkState.ALL, page: 1 }, this.listWorks),
            },
            {
                id: WorkState.ACTIVE,
                title: I18nUtils.tr('TR_ACTIVAS'),
                onClick: () => this.setState({ filter: WorkState.ACTIVE, page: 1 }, this.listWorks),
            },
            {
                id: WorkState.INACTIVE,
                title: I18nUtils.tr('TR_INACTIVAS'),
                onClick: () => this.setState({ filter: WorkState.INACTIVE, page: 2 }, this.listWorks),
            },
        ];
    };

    filterOptions = () => {
        return this.state.filters.map((filter) => ( {
            ...filter,
            active: filter.id === this.state.filter,
        } ));
    };

    subtitle = () => {
        const currentFilter = this.state.filters.find((f) => f.id === this.state.filter);
        return currentFilter ? currentFilter.title : '';
    };
}

WorkListCard.propTypes = {
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object,
    companyManagement: PropTypes.string.isRequired,
};

WorkListCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        search: '',
        filter: WorkState.ALL,
        collapsed: false,
    },
};

const mapStateToProps = (state, ownProps) => {
    return {
        currentUser: CurrentUser.fromReduxState(state),
    }
};

export default connect(mapStateToProps)(WorkListCard);



// WEBPACK FOOTER //
// ./src/app/shared/work/list/WorkListCard.jsx